import React from 'react';
import bannerImgIyi from '@/assets/images/banner-iyi-img.webp';
import { navigateToURL } from '@/utility/navigate';

export default function BannerIYI() {
  return (
    <div className="tw-px-7 tw-py-4 tw-rounded-[1.25rem] tw-bg-[#E0D5F5] tw-flex tw-items-center tw-justify-between tw-w-full">
      <div className="tw-flex tw-gap-5 tw-flex-col">
        <h3 className="tw-text-3xl">Invest Your Interest (IYI)</h3>
        <div>
          <h4 className="tw-text-2xl tw-mb-[0.375rem] tw-font-dmbold tw-text-[#1C2507]">
            Earn 15%* EXTRAAA
          </h4>
          <p className="tw-text-xl tw-font-dmreg">
            by investing your savings account interest into Index Funds (ETFs).
          </p>
        </div>
        <button
          className="tw-bg-white tw-rounded-[6.25rem] tw-px-[3.125rem] tw-py-3 tw-text-base tw-font-medium tw-w-max"
          onClick={() => navigateToURL('/digital-bank/investment')}
        >
          Know More
        </button>
      </div>
      <div className="">
        <div className="tw-flex tw-justify-center">
          <img src={bannerImgIyi} alt="banner image" className="tw-w-[9.375rem] tw-h-[7.5rem]" />
        </div>
      </div>
    </div>
  );
}
